<main role="main" id="content" tabindex="-1">
  <div [ngClass]="{ 'margin-container': !userService.isAidQuiz }">
    @if (we.sessionId !== '') {
      <p class="h2" role="status" aria-live="polite">Loading previously stored session…</p>
    }

    @if (we.errorMsg | async; as errorMsg) {
      <div class="alert alert-danger" role="alert">{{ errorMsg }}</div>
    }
  </div>

  @if (ups.preferences(); as prefs) {
    @if (we.sessionState | async; as sessionState) {
      @if (userService.isAidQuiz === false) {
        <!-- NPC Path -->
        <div class="welcome-page">
          @if (welcomeImageUrl(); as imageUrl) {
            @if (!welcomeImageFailed()) {
              <img
                class="welcome-image"
                [src]="imageUrl"
                alt=""
                (error)="onWelcomeImageError()"
              />
            }
          }

          <div class="welcome-panel" [ngStyle]="{ 'background-color': prefs.panelColor }">
            <div class="welcome-hero">
              <div class="welcome-cta">
                <h1 class="welcome-headline">
                  <span class="welcome-eyebrow">Net Price Calculator</span>
                  <span class="welcome-headline-text">
                    See what {{ prefs.universityName }} could cost for your family
                  </span>
                </h1>
                <p class="welcome-sub">
                  Answer a few questions to receive a personalized estimate based on your household and finances.
                </p>
                <button
                  mat-raised-button
                  color="primary"
                  (click)="start()"
                  [disabled]="isStartDisabled(sessionState)"
                  [attr.aria-busy]="isStartDisabled(sessionState) ? true : null"
                  type="button"
                  class="welcome-start"
                >
                  {{ startLabel(sessionState) }}
                </button>
                <p class="welcome-micro">
                  About 5 minutes · No sign-in required · Your information stays private
                </p>
                <p class="welcome-terms">
                  By using the Net Price Calculator, you agree to the College Board’s
                  <a
                    href="#terms"
                    aria-haspopup="dialog"
                    (click)="showTerms($event)"
                  >terms and conditions</a>
                  and
                  <a
                    href="https://about.collegeboard.org/privacy-center/privacy-statement"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    privacy statement
                    <span class="visually-hidden">(opens in a new window)</span>
                  </a>
                </p>
              </div>

              <div class="welcome-chart">
                <app-aid-cost-illustration />
              </div>
            </div>

            @if (hasSchoolContentBlock()) {
              <div
                class="welcome-school"
                [class.welcome-school--single]="!(hasWelcomeIntro() && hasWelcomeNotes())"
              >
                @if (hasWelcomeIntro()) {
                  <section class="welcome-intro" aria-labelledby="welcome-intro-heading">
                    <h2 id="welcome-intro-heading" class="welcome-section-title">Welcome</h2>
                    <div class="welcome-html" [innerHTML]="ups.content()['welcomeIntro']"></div>
                  </section>
                }

                @if (hasWelcomeNotes()) {
                  <section class="welcome-before" aria-labelledby="welcome-before-heading">
                    <h2 id="welcome-before-heading" class="welcome-section-title">Before you begin</h2>
                    <div class="welcome-html" [innerHTML]="ups.content()['welcomeDisclaimer']"></div>
                  </section>
                }
              </div>
            }

            @if (sessionState === 'missing') {
              <div class="alert alert-danger" role="alert">
                Session was not found, it may have expired.
              </div>
            }
            @if (sessionState === 'incomplete') {
              <div class="alert alert-danger" role="alert">
                Loaded information was not complete. Please answer remaining questions to calculate results.
              </div>
            }
          </div>
        </div>
      } @else {
        <!-- Aid Quiz Path -->
        @if (welcomeImageUrl(); as imageUrl) {
          @if (!welcomeImageFailed()) {
            <img
              class="welcomeImageEFC"
              [src]="imageUrl"
              alt=""
              (error)="onWelcomeImageError()"
            />
          }
        }
        <div class="welcome-efc" [ngStyle]="{ 'background-color': prefs.panelColor }">
          <div [innerHTML]="ups.content()['welcomeIntro']"></div>
          <div class="efc-button-bar">
            <button
              mat-raised-button
              color="primary"
              (click)="start()"
              [disabled]="isStartDisabled(sessionState)"
              [attr.aria-busy]="isStartDisabled(sessionState) ? true : null"
              type="button"
              class="get-started"
            >
              {{ aidQuizStartLabel(sessionState) }}
            </button>
          </div>
          <div class="terms">
            By using the Financial Aid Quiz, you agree to the College Board’s
            <a href="#terms" aria-haspopup="dialog" (click)="showTerms($event)">terms and conditions</a>
            and
            <a
              href="https://about.collegeboard.org/privacy-center/privacy-statement"
              target="_blank"
              rel="noopener noreferrer"
            >
              privacy statement
              <span class="visually-hidden">(opens in a new window)</span>
            </a>
          </div>
          @if (sessionState === 'missing') {
            <div class="alert alert-danger" role="alert">
              Session was not found, it may have expired.
            </div>
          }
          @if (sessionState === 'incomplete') {
            <div class="alert alert-danger" role="alert">
              Loaded information was not complete. Please answer remaining questions to calculate results.
            </div>
          }
        </div>
      }
    }
  }
</main>
